import { IBieuMauNguoiDung } from "../../../model/response/quan-ly-bieu-mau/IBieuMauNguoiDung";
import { IBieuMauNguoiDungFieldChucNang } from "../../../model/response/quan-ly-bieu-mau/IBieuMauNguoiDungFieldChucNang";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eBieuMauNguoiDungActionsObj = {
    LOAD_START: undefined,
    LOAD_SUCCESS: {} as IBieuMauNguoiDung[], // Replace with the actual type if known
    LOAD_ERROR: "",

    LOAD_FIELDS_BY_CHUC_NANG_START: "",
    LOAD_FIELDS_BY_CHUC_NANG_SUCCESS: {} as IBieuMauNguoiDungFieldChucNang[], // Replace with the actual type if known
    LOAD_FIELDS_BY_CHUC_NANG_ERROR: "",

    SHOW_EDIT_MODAL: {} as IBieuMauNguoiDung | undefined, // Replace with the actual type if known
    CLOSE_EDIT_MODAL: undefined,

    SAVE_START: {} as IBieuMauNguoiDung, // Replace with the actual type if known
    SAVE_SUCCESS: undefined,
    SAVE_ERROR: "",

    DELETE_START: 0,
    DELETE_SUCCESS: undefined,
    DELETE_ERROR: "",
}

export const eBieuMauNguoiDungActionIds = generateActionTypeIds(eBieuMauNguoiDungActionsObj, "BIEU_MAU_NGUOI_DUNG");
export type IBieuMauNguoiDungActionTypes = IGenericActionType<typeof eBieuMauNguoiDungActionsObj, "BIEU_MAU_NGUOI_DUNG">;